module.exports = __webpack_public_path__ + "img/GitHub-Light.5196d57e.png";